import { render, staticRenderFns } from "./proposalsPrioritization.vue?vue&type=template&id=c2fa333c&scoped=true&"
import script from "./proposalsPrioritization.vue?vue&type=script&lang=ts&"
export * from "./proposalsPrioritization.vue?vue&type=script&lang=ts&"
import style0 from "./proposalsPrioritization.vue?vue&type=style&index=0&id=c2fa333c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2fa333c",
  null
  
)

export default component.exports